<!--
  This is a special multiple select box that has an input filter field and each selected item
  is displayed as a tag.
-->

<template lang="pug">
  .super-select(:class="{'is-invalid': !valid}")
    .entry-area(@click="focusEntry()")
      Tag(v-if="taggable"
        v-for="tag in value"
        :key="tag[valueName] || tag"
        :content="tag"
        :label-name="labelName"
        @removeTag="toggleSelected(arguments[0])")
      input.entry-box(
        type="text"
        ref="entryArea"
        @input="$emit('filter', $event.target.value)"
        autocomplete="off")
    .selection-area(v-if="options.length > 0")
      .selection-item(v-for="opt in options",@click="toggleSelected(opt)")
        .form-check
          input.form-check-input(type="checkbox"
            :checked="isIn(value, opt)"
            autocomplete="off")
          label.form-check-label {{ opt[labelName] || opt }}
</template>

<script>
import Tag from './Tag'
import isEqual from 'lodash/isEqual'
import { isIn } from '@/lib/utils'

export default {
  name: 'SuperSelect',
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    taggable: {
      type: Boolean,
      default: false,
    },
    labelName: {
      type: String,
      default: '',
    },
    valueName: {
      type: String,
      default: '',
    },
    value: {
      type: Array,
      default: () => [],
    },
    valid: {
      type: Boolean,
      default: true,
    },
  },
  data: function() {
    return {
      selectedOptions: [],
    }
  },
  methods: {
    isIn,
    toggleSelected: function(opt) {
      let selected = [...this.value]
      if (isIn(selected, opt)) {
        selected = selected.filter(del => !isEqual(del, opt))
      } else {
        selected.push(opt)
        this.$emit('filter', '')
        this.$refs.entryArea.value = ''
      }
      this.$emit('input', selected)
    },
    focusEntry: function() {
      this.$refs.entryArea.focus()
    },
  },
  computed: {
    tags() {
      if (this.valueName !== '') {
        return this.options
          .filter(v => this.value.includes(v[this.valueName]))
          .map(v => v[this.labelName])
      }
    },
  },
  components: {
    Tag,
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/custom';
.super-select {
  border: 1px solid #cccccc;
  background: white;
}
.super-select.is-invalid {
  border: 1px solid #dc3545;
}
.entry-area {
  padding: 0.5rem;
  border-bottom: 1px solid #cccccc;
  display: flex;
  flex-wrap: wrap;
}
.entry-box {
  margin-left: 1rem;
  border: none;
  flex: 2;
}
.entry-box:focus {
  outline: none;
}
.selection-area {
  max-height: 20rem;
  overflow-y: auto;
}
.selection-item {
  padding: 0.8rem;
  margin: 0.1rem;
}
// Border on every selection item but the first.
.selection-item:not(:first-child) {
  border-top: 1px solid #cccccc;
}
.selection-item:hover {
  outline: 3px solid $primary;
  cursor: pointer;
  user-select: none;
}
</style>
